import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';
import { DatasourceColumnsProps } from '../../../types/reduxTypes/datasourceColumns';

const createReducer = <T extends SliceCaseReducers<DatasourceColumnsProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setDatasourceColumnsData(state, action) {
    state.datasourceColumnsData = action.payload;
  }
});

export default reducers;
